(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("styled-components"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "styled-components"], factory);
	else if(typeof exports === 'object')
		exports["sofa"] = factory(require("react"), require("react-dom"), require("styled-components"));
	else
		root["sofa"] = factory(root["react"], root["react-dom"], root["styled-components"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__9514__, __WEBPACK_EXTERNAL_MODULE__8694__) => {
return 